export default __webpack_public_path__ + "static/media/Rapidonkey_Loader.da834b71.gif";